import type { PropsWithoutRef } from 'react';

import { twMerge } from 'tailwind-merge';

import { Card, CardBody } from '@/_components';
import type { DivProps } from '@/types';

export type CardContainerType = PropsWithoutRef<DivProps & { bodyClassName?: string; right?: boolean }>;

export function CardContainer({ children, bodyClassName, right, ...props }: CardContainerType) {
  return (
    <Card {...props}>
      <CardBody className={twMerge(right ? '3xl:px-8 px-6' : '3xl:px-10 px-8', bodyClassName)}>{children}</CardBody>
    </Card>
  );
}
